<section id="info" class="relative scroll-mt-28 overflow-hidden border-t border-surface bg-surface-50 dark:bg-white/5">
    <app-landing-glow [variant]="8" />
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div class="max-w-3xl">
            <div class="text-sm font-semibold uppercase tracking-[0.3em] text-primary">{{ text().infoTitle }}</div>
            <h2 class="mt-4 text-3xl font-semibold text-surface-900 sm:text-4xl dark:text-white">{{ text().infoSubtitle }}</h2>
        </div>

        <div class="mt-10 grid gap-5 lg:grid-cols-3">
            @for (card of text().infoCards; track card.title; let i = $index) {
                <article [appRevealOnScroll]="i * 90" class="rounded-3xl border border-surface bg-surface-0 p-6 shadow-lg shadow-black/15 dark:bg-surface-900/80">
                    <div class="text-sm font-semibold uppercase tracking-[0.24em] text-muted-color">Feature</div>
                    <h3 class="mt-4 text-2xl font-semibold text-surface-900 dark:text-white">{{ card.title }}</h3>
                    <p class="mt-3 leading-7 text-muted-color">{{ card.description }}</p>
                </article>
            }
        </div>
    </div>
</section>
